import React from "react";
import { Select } from "components/select/index";
import DraggableEditInput from "components/draggableEditInput/DraggableEditInput";
import { useTournamentRegistrationContext } from "../TournamentRegistrationContext";
import CustomSelectEdit from "pages/secure/facility/settings/forms/customEdits/CustomSelectEdit";
import CustomInputEdit from "pages/secure/facility/settings/forms/customEdits/CustomInputEdit";
import Input from "components/form/input/Input";
import CustomCheckboxEdit from "pages/secure/facility/settings/forms/customEdits/CustomCheckboxEdit";
import Checkbox from "components/form/checkbox/Checkbox";
import CustomTextEdit from "pages/secure/facility/settings/forms/customEdits/CustomTextEdit";
import TextField from "components/form/textField/TextField";
import { ITournamentRegistrationInput } from "api/rpc/2024-04/facilityAdmin/tournament/registration/inputs";

interface IProps {
  input: ITournamentRegistrationInput;
}

export default function TournamentRegistrationEditInput(props: IProps) {
  const { Option } = Select;

  const { input } = props;

  const tournamentRegistrationContext = useTournamentRegistrationContext();

  return (
    <DraggableEditInput
      item={input}
      rows={tournamentRegistrationContext.inputRowsContainer?.updatedState}
      setSelectedEditInput={tournamentRegistrationContext.setSelectedInput}
    >
      {input.type === "select" && (
        <CustomSelectEdit
          label={input.label}
          helpText={input.help_text}
          array={input.values}
          required={input.required}
          saveInput={(label, values, helpText, required) =>
            tournamentRegistrationContext.handleUpdateInput(input.id, label, helpText, values, required)
          }
          editModalOpen={
            tournamentRegistrationContext.selectedInput.id === input.id &&
            tournamentRegistrationContext.selectedInput.editModalOpen
          }
          closeEditModal={tournamentRegistrationContext.closeInputEditModal}
        >
          <Select label={input.label} helpText={input.help_text}>
            {!input.values || input?.values?.length < 1 ? (
              <Option key={"empty"} value={""}></Option>
            ) : (
              <>
                {input.values.map((value: string, index: number) => (
                  <Option key={index} value={value}>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "18px",
                      }}
                    >
                      {value}
                    </span>
                  </Option>
                ))}
              </>
            )}
          </Select>
        </CustomSelectEdit>
      )}

      {input.type === "input" && (
        <CustomInputEdit
          label={input.label}
          helpText={input.help_text}
          required={input.required}
          saveInput={(label, value, helpText, assignedAttribute, required) =>
            tournamentRegistrationContext.handleUpdateInput(input.id, label, helpText, null, required)
          }
          editModalOpen={
            tournamentRegistrationContext.selectedInput.id === input.id &&
            tournamentRegistrationContext.selectedInput.editModalOpen
          }
          closeEditModal={tournamentRegistrationContext.closeInputEditModal}
        >
          <Input id={input.id} label={input.label} helpText={input.help_text} defaultValue={input.values} readOnly />
        </CustomInputEdit>
      )}

      {input.type === "checkbox" && (
        <CustomCheckboxEdit
          label={input.label}
          helpText={input.help_text}
          required={input.required}
          options={input.values}
          saveInput={(label, helpText, required) =>
            tournamentRegistrationContext.handleUpdateInput(input.id, label, helpText, null, required)
          }
          editModalOpen={
            tournamentRegistrationContext.selectedInput.id === input.id &&
            tournamentRegistrationContext.selectedInput.editModalOpen
          }
          closeEditModal={tournamentRegistrationContext.closeInputEditModal}
        >
          <Checkbox size="medium" label={input.label} supportText={input.help_text} checked={false} readOnly />
        </CustomCheckboxEdit>
      )}

      {input.type === "text" && (
        <CustomTextEdit
          label={input.label}
          description={input.help_text}
          saveInput={(label: string, description: string) =>
            tournamentRegistrationContext.handleUpdateInput(input.id, label, description, null)
          }
          editModalOpen={
            tournamentRegistrationContext.selectedInput.id === input.id &&
            tournamentRegistrationContext.selectedInput.editModalOpen
          }
          closeEditModal={tournamentRegistrationContext.closeInputEditModal}
        >
          <TextField label={input.label} value={input.help_text} readOnly />
        </CustomTextEdit>
      )}
    </DraggableEditInput>
  );
}
